import React from 'react'
import {
    BackButton,
    Bloc,
    BlocTextField,
    Button,
    Conditionnal,
    Header,
    ProgressBar,
    Title,
} from '../ImportAll'

export default function Vue10() {
    return (
        <div>
            <Header
                title="J'estime mon prêt"
                subTitle="Quelle est la situation professionnelle du premier emprunteur? (vous)"
            />
            <div className="Container">
                <div className="BackNavigationContainerLeft">
                    <BackButton />
                </div>
            </div>
            <div className="Container">
                <ProgressBar size={60} time={2} />
            </div>
            <div className="Container">
                <Conditionnal linked_data_id="emprunteurs_cat_emploi_1" isEmpty>
                    <Bloc
                        key="key60"
                        selectable
                        linked_data_id="emprunteurs_cat_emploi_1"
                        linked_data_value="PRIVE"
                        nbcolumn={1}
                        simpleDoubleWord
                        text1="Salarié du privé"
                        text2="CDI cadre, CDI non cadre, CDI en période d’essai, CDD, Intérimaire, Intermittent du spectacle"
                    />
                    <Bloc
                        key="key61"
                        selectable
                        linked_data_id="emprunteurs_cat_emploi_1"
                        linked_data_value="PUBLIC"
                        nbcolumn={1}
                        simpleDoubleWord
                        text1="Salarié du public"
                        text2="Titulaire, Contractuel, Stagiaire"
                    />
                    <Bloc
                        key="key62"
                        selectable
                        linked_data_id="emprunteurs_cat_emploi_1"
                        linked_data_value="NS"
                        nbcolumn={1}
                        simpleDoubleWord
                        text1="Travailleur non salarié"
                        text2="Chef d’entreprise, Profession libérale, Artisan, Agriculteur, Travailleur indépendant Auto-entrepreneur, Commerçant"
                    />
                    <Bloc
                        key="key63"
                        selectable
                        linked_data_id="emprunteurs_cat_emploi_1"
                        linked_data_value="AUTRE"
                        nbcolumn={1}
                        simpleDoubleWord
                        text1="Autres"
                        text2="Congé parental, Retraité du secteur privé, Retraité du secteur public, En recherche d’emploi, Etudiant, Sans profession"
                    />
                </Conditionnal>

                <Conditionnal
                    linked_data_id="emprunteurs_cat_emploi_1"
                    isEqualTo
                    targetDataValueCompare="PRIVE"
                >
                    <Bloc
                        key="key64"
                        selectable
                        forceSelected
                        linked_data_id="emprunteurs_cat_emploi_1"
                        linked_data_value_empty
                        nbcolumn={1}
                        simpleWord
                        text1="Salarié du privé"
                    />
                    <Title maintitle="Quel est votre statut ?" />
                    <Bloc
                        key="key65"
                        selectable
                        linked_data_id="emprunteurs_type_emploi_1"
                        linked_data_value="PRIVE_CDI_CADRE"
                        nbcolumn={2}
                        gauche
                        simpleWord
                        text1="CDI cadre"
                    />
                    <Bloc
                        key="key66"
                        selectable
                        linked_data_id="emprunteurs_type_emploi_1"
                        linked_data_value="PRIVE_CDI_NON_CADRE"
                        nbcolumn={2}
                        droit
                        simpleWord
                        text1="CDI non cadre"
                    />
                    <Bloc
                        key="key67"
                        selectable
                        linked_data_id="emprunteurs_type_emploi_1"
                        linked_data_value="PRIVE_CDI_ESSAI"
                        nbcolumn={2}
                        gauche
                        simpleWord
                        text1="CDI en période d’essai"
                    />
                    <Bloc
                        key="key68"
                        selectable
                        linked_data_id="emprunteurs_type_emploi_1"
                        linked_data_value="PRIVE_CDD"
                        nbcolumn={2}
                        droit
                        simpleWord
                        text1="CDD"
                    />
                    <Bloc
                        key="key69"
                        selectable
                        linked_data_id="emprunteurs_type_emploi_1"
                        linked_data_value="PRIVE_INTERIM"
                        nbcolumn={2}
                        gauche
                        simpleWord
                        text1="Intérimaire"
                    />
                    <Bloc
                        key="key70"
                        selectable
                        linked_data_id="emprunteurs_type_emploi_1"
                        linked_data_value="PRIVE_INTERMITTENT"
                        nbcolumn={2}
                        droit
                        simpleWord
                        text1="Intermittent du spectacle"
                    />
                </Conditionnal>

                <Conditionnal
                    linked_data_id="emprunteurs_cat_emploi_1"
                    isEqualTo
                    targetDataValueCompare="PUBLIC"
                >
                    <Bloc
                        key="key71"
                        selectable
                        forceSelected
                        linked_data_id="emprunteurs_cat_emploi_1"
                        linked_data_value_empty
                        nbcolumn={1}
                        simpleWord
                        text1="Salarié du public"
                    />
                    <Title maintitle="Quel est votre statut ?" />
                    <Bloc
                        key="key72"
                        selectable
                        linked_data_id="emprunteurs_type_emploi_1"
                        linked_data_value="PUBLIC_TITULAIRE"
                        nbcolumn={2}
                        gauche
                        simpleWord
                        text1="Titulaire"
                    />
                    <Bloc
                        key="key73"
                        selectable
                        linked_data_id="emprunteurs_type_emploi_1"
                        linked_data_value="PUBLIC_CONTRACTUEL"
                        nbcolumn={2}
                        droit
                        simpleWord
                        text1="Contractuel"
                    />
                    <Bloc
                        key="key74"
                        selectable
                        linked_data_id="emprunteurs_type_emploi_1"
                        linked_data_value="PUBLIC_STAGIAIRE"
                        nbcolumn={2}
                        gauche
                        simpleWord
                        text1="Stagiaire"
                    />
                </Conditionnal>

                <Conditionnal
                    linked_data_id="emprunteurs_cat_emploi_1"
                    isEqualTo
                    targetDataValueCompare="NS"
                >
                    <Bloc
                        key="key75"
                        selectable
                        forceSelected
                        linked_data_id="emprunteurs_cat_emploi_1"
                        linked_data_value_empty
                        nbcolumn={1}
                        simpleWord
                        text1="Travailleur non salarié"
                    />
                    <Title maintitle="Quel est votre statut ?" />
                    <Bloc
                        key="key76"
                        selectable
                        linked_data_id="emprunteurs_type_emploi_1"
                        linked_data_value="NS_CHEF_ENTREPRISE"
                        nbcolumn={2}
                        gauche
                        simpleWord
                        text1="Chef d’entreprise"
                    />
                    <Bloc
                        key="key77"
                        selectable
                        linked_data_id="emprunteurs_type_emploi_1"
                        linked_data_value="NS_PRO_LIBERALE"
                        nbcolumn={2}
                        droit
                        simpleWord
                        text1="Profession libérale"
                    />
                    <Bloc
                        key="key78"
                        selectable
                        linked_data_id="emprunteurs_type_emploi_1"
                        linked_data_value="NS_ARTISAN"
                        nbcolumn={2}
                        gauche
                        simpleWord
                        text1="Artisan"
                    />
                    <Bloc
                        key="key79"
                        selectable
                        linked_data_id="emprunteurs_type_emploi_1"
                        linked_data_value="NS_AGRI"
                        nbcolumn={2}
                        droit
                        simpleWord
                        text1="Agriculteur"
                    />
                    <Bloc
                        key="key80"
                        selectable
                        linked_data_id="emprunteurs_type_emploi_1"
                        linked_data_value="NS_INDEPENDANT"
                        nbcolumn={2}
                        gauche
                        simpleWord
                        text1="Travailleur indépendant / Auto-entrepreneur"
                    />
                    <Bloc
                        key="key81"
                        selectable
                        linked_data_id="emprunteurs_type_emploi_1"
                        linked_data_value="NS_COMMERCANT"
                        nbcolumn={2}
                        droit
                        simpleWord
                        text1="Commerçant"
                    />

                    <Conditionnal
                        linked_data_id="emprunteurs_type_emploi_1"
                        isNotEmpty
                    >
                        <Title maintitle="Combien de bilans avez-vous?" />
                        <Conditionnal
                            linked_data_id="emprunteurs_type_emploi_1"
                            isEqualTo
                            targetDataValueCompare="NS_PRO_LIBERALE"
                        >
                            <Bloc
                                key="key76"
                                selectable
                                linked_data_id="emprunteurs_emploi_bilan_1"
                                linked_data_value="SUFFISANT"
                                nbcolumn={2}
                                gauche
                                simpleWord
                                text1="Plus de 2 bilans"
                            />
                            <Bloc
                                key="key77"
                                selectable
                                linked_data_id="emprunteurs_emploi_bilan_1"
                                linked_data_value="INSUFFISANT"
                                nbcolumn={2}
                                droit
                                simpleWord
                                text1="Moins de 2 bilans"
                            />
                        </Conditionnal>
                        <Conditionnal
                            linked_data_id="emprunteurs_type_emploi_1"
                            isNotEqualTo
                            targetDataValueCompare="NS_PRO_LIBERALE"
                        >
                            <Bloc
                                key="key76"
                                selectable
                                linked_data_id="emprunteurs_emploi_bilan_1"
                                linked_data_value="SUFFISANT"
                                nbcolumn={2}
                                gauche
                                simpleWord
                                text1="Plus de 3 bilans"
                            />
                            <Bloc
                                key="key77"
                                selectable
                                linked_data_id="emprunteurs_emploi_bilan_1"
                                linked_data_value="INSUFFISANT"
                                nbcolumn={2}
                                droit
                                simpleWord
                                text1="Moins de 3 bilans"
                            />
                        </Conditionnal>
                    </Conditionnal>
                </Conditionnal>

                <Conditionnal
                    linked_data_id="emprunteurs_cat_emploi_1"
                    isEqualTo
                    targetDataValueCompare="AUTRE"
                >
                    <Bloc
                        key="key82"
                        selectable
                        forceSelected
                        linked_data_id="emprunteurs_cat_emploi_1"
                        linked_data_value_empty
                        nbcolumn={1}
                        simpleWord
                        text1="Autres"
                    />
                    <Title maintitle="Quel est votre statut ?" />
                    <Bloc
                        key="key83"
                        selectable
                        linked_data_id="emprunteurs_type_emploi_1"
                        linked_data_value="AUTRE_CP"
                        nbcolumn={2}
                        gauche
                        simpleWord
                        text1="Congé parental"
                    />
                    <Bloc
                        key="key84"
                        selectable
                        linked_data_id="emprunteurs_type_emploi_1"
                        linked_data_value="AUTRE_RET_PRIVE"
                        nbcolumn={2}
                        droit
                        simpleWord
                        text1="Retraité du secteur privé"
                    />
                    <Bloc
                        key="key85"
                        selectable
                        linked_data_id="emprunteurs_type_emploi_1"
                        linked_data_value="AUTRE_RET_PUBLIC"
                        nbcolumn={2}
                        gauche
                        simpleWord
                        text1="Retraité du secteur public"
                    />
                    <Bloc
                        key="key86"
                        selectable
                        linked_data_id="emprunteurs_type_emploi_1"
                        linked_data_value="AUTRE_RECH_EMPLOI"
                        nbcolumn={2}
                        droit
                        simpleWord
                        text1="En recherche d’emploi"
                    />
                    <Bloc
                        key="key87"
                        selectable
                        linked_data_id="emprunteurs_type_emploi_1"
                        linked_data_value="AUTRE_ETUDIANT"
                        nbcolumn={2}
                        gauche
                        simpleWord
                        text1="Etudiant"
                    />
                    <Bloc
                        key="key88"
                        selectable
                        linked_data_id="emprunteurs_type_emploi_1"
                        linked_data_value="AUTRE_SANS_PROFESSION"
                        nbcolumn={2}
                        droit
                        simpleWord
                        text1="Sans profession"
                    />
                </Conditionnal>
            </div>

            <Conditionnal
                linked_data_id="emprunteurs_type_emploi_1"
                isEqualTo
                targetDataValueCompare="PRIVE_CDD"
            >
                <div className="Container">
                    <Title
                        maintitle="Vous avez un salaire tous les mois depuis : "
                        secondarytitle="hors revenus sociaux"
                    />
                    <Bloc
                        key="key90"
                        selectable
                        linked_data_id="emprunteurs_duree_salaire_1"
                        linked_data_value="MOINS_2_ANS"
                        nbcolumn={3}
                        milieu
                        simpleWord
                        text1="Moins de deux ans"
                    />
                    <Bloc
                        key="key91"
                        selectable
                        linked_data_id="emprunteurs_duree_salaire_1"
                        linked_data_value="PLUS_2_ANS"
                        nbcolumn={3}
                        droit
                        simpleWord
                        text1="Plus de deux ans"
                    />
                </div>
            </Conditionnal>

            <Conditionnal
                linked_data_id="emprunteurs_type_emploi_1"
                isEqualTo
                targetDataValueCompare="PRIVE_INTERIM"
            >
                <div className="Container">
                    <Title
                        maintitle="Vous avez un salaire tous les mois depuis : "
                        secondarytitle="hors revenus sociaux"
                    />
                    <Bloc
                        key="key93"
                        selectable
                        linked_data_id="emprunteurs_duree_salaire_1"
                        linked_data_value="MOINS_2_ANS"
                        nbcolumn={3}
                        milieu
                        simpleWord
                        text1="Moins de deux ans"
                    />
                    <Bloc
                        key="key94"
                        selectable
                        linked_data_id="emprunteurs_duree_salaire_1"
                        linked_data_value="PLUS_2_ANS"
                        nbcolumn={3}
                        droit
                        simpleWord
                        text1="Plus de deux ans"
                    />
                </div>
            </Conditionnal>

            <Conditionnal
                linked_data_id="emprunteurs_type_emploi_1"
                isEqualTo
                targetDataValueCompare="PRIVE_INTERMITTENT"
            >
                <div className="Container">
                    <Title
                        maintitle="Vous avez un salaire tous les mois depuis : "
                        secondarytitle="hors revenus sociaux"
                    />
                    <Bloc
                        key="key96"
                        selectable
                        linked_data_id="emprunteurs_duree_salaire_1"
                        linked_data_value="MOINS_2_ANS"
                        nbcolumn={3}
                        milieu
                        simpleWord
                        text1="Moins de deux ans"
                    />
                    <Bloc
                        key="key97"
                        selectable
                        linked_data_id="emprunteurs_duree_salaire_1"
                        linked_data_value="PLUS_2_ANS"
                        nbcolumn={3}
                        droit
                        simpleWord
                        text1="Plus de deux ans"
                    />
                </div>
            </Conditionnal>

            <Conditionnal
                linked_data_id="emprunteurs_type_emploi_1"
                isEqualTo
                targetDataValueCompare="NS_INDEPENDANT"
            >
                <div className="Container">
                    <Title
                        maintitle="Vous avez un salaire tous les mois depuis : "
                        secondarytitle="hors revenus sociaux"
                    />
                    <Bloc
                        key="key99"
                        selectable
                        linked_data_id="emprunteurs_duree_salaire_1"
                        linked_data_value="MOINS_2_ANS"
                        nbcolumn={3}
                        milieu
                        simpleWord
                        text1="Moins de deux ans"
                    />
                    <Bloc
                        key="key100"
                        selectable
                        linked_data_id="emprunteurs_duree_salaire_1"
                        linked_data_value="PLUS_2_ANS"
                        nbcolumn={3}
                        droit
                        simpleWord
                        text1="Plus de deux ans"
                    />
                </div>
            </Conditionnal>

            <div className="Container">
                <Title maintitle="Quel âge avez-vous ?" />
                <BlocTextField
                    nbcolumn={1}
                    linked_data_id="emprunteurs_date_naissance_1"
                    label="Date de naissance"
                    placeholder="Ex : jour/mois/année : 30/05/1991"
                    checkedByRegex={
                        /^(((0[1-9]|[12][0-9]|30)[/]{1}(0[13-9]|1[012])|31[/]{1}(0[13578]|1[02])|(0[1-9]|1[0-9]|2[0-8])[/]{1}02)[/]{1}[0-9]{4}|29[/]{1}02[/]{1}([0-9]{2}(([2468][048]|[02468][48])|[13579][26])|([13579][26]|[02468][048]|0[0-9]|1[0-6])00))$/
                    }
                    messageErreur={'Vous devez avoir entre 18 et 80 ans'}
                    verificationAge18a80Ans
                    autoCompletionDate
                />
            </div>

            <Conditionnal linked_data_id="emprunteurs_type_emploi_1" isNotEmpty>
                <Conditionnal
                    linked_data_id="emprunteurs_date_naissance_1_validated"
                    isEqualTo
                    targetDataValueCompare={true}
                >
                    <Conditionnal
                        linked_data_id="emprunteurs_cat_emploi_1"
                        isEqualTo
                        targetDataValueCompare="NS"
                    >
                        <Conditionnal
                            linked_data_id="emprunteurs_emploi_bilan_1"
                            isNotEmpty
                        >
                            <div className="SubmitButtonContainer">
                                {' '}
                                <Button text="Suivant" targetView={11} />{' '}
                            </div>
                        </Conditionnal>
                    </Conditionnal>
                    <Conditionnal
                        linked_data_id="emprunteurs_cat_emploi_1"
                        isNotEqualTo
                        targetDataValueCompare="NS"
                    >
                        <div className="SubmitButtonContainer">
                            {' '}
                            <Button text="Suivant" targetView={11} />{' '}
                        </div>
                    </Conditionnal>
                </Conditionnal>
            </Conditionnal>
        </div>
    )
}
